import { ExtractBaseURL } from "../shared/ExtractBaseURL/ExtractBaseURL";
export const BASE_NAME = "/fhir";
let ExtractedBaseURL = ExtractBaseURL();


// @name NAVIGATE_TO
// @desc here all the navigation to components values are declared.
// @author Sahithi
export const NAVIGATE_TO = {
  CONTACT: "/Contact",
  DOCUMENTATION: "/documentation",
  PAGE_NOT_FOUND: "/404-not-found",
  SUPPORTED_SYSTEM_OPERATIONS: "/supported-system-operations",
  SUPPORTED_RESOURCES_DETAILS: "/supported-resources",
  ENTITY_REGISTRATION_APPLICATION: `${
    (ExtractedBaseURL === 'https://totalview.healthos.elevancehealth.com')
      ? 'https://sbx.totalview.healthos.elevancehealth.com'
      : (ExtractedBaseURL === 'https://totalview.healthos.carelon.com')
        ? 'https://sbx.totalview.healthos.carelon.com'
        : ExtractedBaseURL
  }/registration/sandbox/login`,
  IMPORT_MAPPING: "/import-mappings",
  EHC_MAPPING: "/elevancehealth-concepts-mapping",
  PROD_SB_ENTITY_REGISTRATION: "https://sbx.totalview.healthos.elevancehealth.com/registration/sandbox/login",
  //THIRD_PARTY_TEST: `${ExtractedBaseURL}/thirdparty/api/v1/members/smart-test`
  THIRD_PARTY_TEST: `${
    (ExtractedBaseURL === 'https://totalview.healthos.elevancehealth.com')
      ? 'https://sbx.totalview.healthos.elevancehealth.com'
      : (ExtractedBaseURL === 'https://totalview.healthos.carelon.com')
        ? 'https://sbx.totalview.healthos.carelon.com'
        : ExtractedBaseURL
  }/fhirtest`,
};

// @name TEXTS
// @desc here all the constant TEXTS used in components are declared.
// @author Sahithi
export const TEXTS = {
  APPLICATION_HEADER: "FHIR API Documentation",
};

// @name Error_Msgs
// @desc here all the Error Msgs used are declared.
// @author Sahithi
export const Error_Msgs = {
  least_char: ` characters must be more than `,
  invalid_format: ` invalid format(eg: anything@anything.com)`,
};

// @name Error_Msgs
// @desc here all the Error Msgs used are declared.
// @author Sahithi
export const ContactStaticText = {
  email: "Email",
  message: "Message",
  contactUs: "Contact Us",
  contactDesc:
    "Can't find what you're looking for? Contact Us and we'll get back to you as soon as we can",
};
